import { ProductCard } from "@/components/product-card";
import { NOT_IMAGE } from "@/lib/constants";

interface RelatedProduct {
  id: string;
  name: string;
  urlKey: string;
  type?: string;
  priceHtml?: {
    regularPrice?: string;
    currencyCode?: string;
  };
  images?: { url: string }[];
}

interface SimilarProductsProps {
  products?: RelatedProduct[];
}

const staticProducts: RelatedProduct[] = [
  {
    id: "1",
    name: "ALLOY WHEEL 18×8.0 ET40",
    urlKey: "alloy-wheel-1",
    type: "simple",
    priceHtml: { regularPrice: "550", currencyCode: "USD" },
    images: [{ url: "/image/wheels/AlloyWheel.png" }],
  },
  {
    id: "2",
    name: "ALLOY WHEEL 17×7.5 ET35",
    urlKey: "alloy-wheel-2",
    type: "simple",
    priceHtml: { regularPrice: "480", currencyCode: "USD" },
    images: [{ url: "/image/wheels/AlloyWheel1.png" }],
  },
  {
    id: "3",
    name: "ALLOY WHEEL 19×8.5 ET45",
    urlKey: "alloy-wheel-3",
    type: "simple",
    priceHtml: { regularPrice: "720", currencyCode: "USD" },
    images: [{ url: "/image/wheels/AlloyWheel2.png" }],
  },
  {
    id: "4",
    name: "STEEL WHEEL 16×7.0 ET30",
    urlKey: "steel-wheel-1",
    type: "simple",
    priceHtml: { regularPrice: "420", currencyCode: "USD" },
    images: [{ url: "/image/wheels/SteelWheel.png" }],
  },
];

export default function SimilarProducts({ products }: SimilarProductsProps) {
  const displayProducts = products && products.length > 0 ? products : staticProducts;

  return (
    <section className="px-4 sm:px-6 md:px-8 lg:px-20 pt-8 md:pt-12 pb-24 ">
      <h2 className="font-plus-jakarta text-lg md:text-xl font-bold text-neutral-900 mb-6 md:mb-8 uppercase">Similar Wheels</h2>
      
      <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
        {displayProducts.slice(0, 4).map((product) => (
          <ProductCard
            key={product.id}
            currency={product.priceHtml?.currencyCode || "USD"}
            imageUrl={product.images?.[0]?.url || NOT_IMAGE}
            price={product.priceHtml?.regularPrice || "0"}
            product={{
              urlKey: product.urlKey,
              name: product.name,
              id: product.id,
              type: product.type || "simple",
            }}
          />
        ))}
      </div>
    </section>
  );
}
